import { render } from "./pending.vue?vue&type=template&id=8d65f35a&scoped=true"
import script from "./pending.vue?vue&type=script&lang=js"
export * from "./pending.vue?vue&type=script&lang=js"

import "./pending.vue?vue&type=style&index=0&id=8d65f35a&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d65f35a"]])

export default __exports__